import { useRef } from 'react';
var initialPosition = { top: 0, right: 0, bottom: 0, left: 0 };
/**
 * Реакт-хук, позволяющий создать виртуальный элемент для попапа.
 */
export function useVirtualElementRef(props) {
    if (props === void 0) { props = {}; }
    var rect = props.rect, contextElement = props.contextElement;
    var rectRef = useRef(initialPosition);
    var ref = useRef({
        contextElement: contextElement,
        getBoundingClientRect: function () {
            var _a = rectRef.current, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                right: right,
                bottom: bottom,
                left: left,
                width: width,
                height: height,
            };
        },
    });
    ref.current.contextElement = contextElement;
    if (rect) {
        var _a = rect.top, top_1 = _a === void 0 ? 0 : _a, _b = rect.left, left = _b === void 0 ? 0 : _b, _c = rect.right, right = _c === void 0 ? left : _c, _d = rect.bottom, bottom = _d === void 0 ? top_1 : _d;
        rectRef.current = { top: top_1, right: right, bottom: bottom, left: left };
    }
    else {
        rectRef.current = initialPosition;
    }
    return ref;
}
